
;
                (function(){
                    const Func = (function() {
                        if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"lightbox","lightbox":"no"};
                    const ID = 'ecom-1sdlodw0vzs';
                    document.querySelectorAll('.ecom-1sdlodw0vzs').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(!this.$el||!window.EComModal)return;let e=this.$el.querySelectorAll("[ecom-modal]");e.length&&new window.EComModal(e,{gallery:!0,cssClass:["ecom-container-lightbox-"+this.id]})
                    
                    });
                    const settings = {};
                    const ID = 'ecom-2ub8uciqpdb';
                    document.querySelectorAll('.ecom-2ub8uciqpdb').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            